import { Component, inject } from '@angular/core';
import { Location } from '@angular/common';
import { LogoComponent } from '../../components/logo/logo.component';

@Component({
  selector: 'app-unauthorized',
  standalone: true,
  imports: [LogoComponent],
  templateUrl: './unauthorized.component.html',
  styleUrl: './unauthorized.component.css',
})
export class UnauthorizedPage {
  private readonly location = inject(Location);

  goBack() {
    this.location.back();
  }
}
